

import React , { useEffect, useState} from "react";

import { useDatasCourtierCompagnies } from "../../../state/reactquery";
import { useAllCompagniesTarifs } from "../../../state/reactquery";

import Button from "../../Buttons/Button";
import { logocompagnie } from "../../../images/images_logoscompagnies";

import './Compagnys.scss' ;
import './AllCompagnys.scss' ;

const classNames = require('classnames');
function AllCompagnys({selectedcompagnie, setSelectedcompagnie}){

    const [displayothercompagny , setDisplayothercompagny] = useState(false) ;
    const {data:allcompagniestarifs}  = useAllCompagniesTarifs() ;
    const {data:datascourtiercompagnies}  = useDatasCourtierCompagnies() ; 


    useEffect(() => {setSelectedcompagnie(allcompagniestarifs?.[0]) ; }, [allcompagniestarifs]); 

    const clickCompagnie =(e)=>{setSelectedcompagnie(allcompagniestarifs?.filter(x=>x.compagnie_mini===e.target.id)?.[0]);}


    const boulettecompagnie = (comp)=>{
        const etatauthcourtier = datascourtiercompagnies?.filter(c=>c.compagnie_mini ===comp.compagnie_mini)[0]
                                                        ?.['courtier_auth'] 

        return(<div  id={comp.compagnie_mini} key={comp.compagnie_mini}    onClick={clickCompagnie}
                        className={classNames("container_imgcompagnies",
                                              {'compagnieno':etatauthcourtier===undefined  && selectedcompagnie?.compagnie_mini!==comp.compagnie_mini  } ,
                                              {'selected':selectedcompagnie?.compagnie_mini===comp.compagnie_mini },
                                              {'compagnieok':etatauthcourtier ==='ok'},
                                              {'compagniewait':etatauthcourtier ==='wait'},
                                              {'compagnierefused':etatauthcourtier ==='refused'})} > 
                    <img src={logocompagnie(comp?.compagnie?.toUpperCase())} width='44' height='44'   alt='logoCompagnie'/>
                </div>) ; 

    }
    const infoscontacts ={}
    const handlechange= (e)=>{console.log(e)}

    return (
      <>
        {displayothercompagny && (
          <div className="containergray">
            <div className="othercompagnie">
              <div className="lineinfocourtier">
               <div className="compagnielabelinput">
                <div className="inputtextelabel">Compagnie</div>
                <input id="compagnie" type="text" autoComplete="off" onChange={handlechange} value={infoscontacts?.compagnie || ""} />
              </div>
              </div>
                <div className="lineinfocourtier">
              <div className="compagnielabelinput">
                <div className="inputtextelabel">Code courtier</div>
                <input id="codecourtier" type="text" autoComplete="off" onChange={handlechange} value={infoscontacts?.codecourtier || ""} />
              </div>
    </div>  
                     <div className="lineinfocourtier">
           
                <div className="compagnielabelinput">
                  <div className="inputtextelabel">Votre inspecteur</div>
                  <input id="nomprenom_inspecteur" type="text" autoComplete="off" onChange={handlechange} value={infoscontacts?.nomprenom_inspecteur || ""} />
                </div>
                <div className="compagnielabelinput">
                  <div className="inputtextelabel">Email inspecteur</div>
                  <input id="email_inspecteur" type="text" autoComplete="off" onChange={handlechange} value={infoscontacts?.email_inspecteur || ""}/>
                </div>
                <div className="compagnielabelinput last">
                  <div className="inputtextelabel">Téléphone inspecteur</div>
                  <input id="tel_inspecteur" type="text" autoComplete="off" onChange={handlechange} value={infoscontacts?.tel_inspecteur || ""}/>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="groupeimgcompagnies">
          {allcompagniestarifs?.sort((a, b) => a.compagnie_mini < b.compagnie_mini? -1: a.compagnie_mini > b.compagnie_mini ? 1: 0)?.map((comp) => boulettecompagnie(comp))}
          <div style={{ width: "40px" }}></div>

          {/* <Button texte="Autre compagnie" color="bouton_color_orange" size="bouton_size_normal" onclick={() => { setDisplayothercompagny(true); }} /> */}
        </div>
      </>
    );

}



export default AllCompagnys ; 



